
import { Observable } from '../../Observable';
import { observeOn } from '../../operator/observeOn';

Observable.prototype.observeOn = observeOn;

declare module '../../Observable' {
  interface Observable<T> {
    observeOn: typeof observeOn;
  }
}


// WEBPACK FOOTER //
// ../../../src/add/operator/observeOn.ts